var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartHomeIconCmu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_849_484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.419 24.5011C53.3912 18.1567 48.2225 13.002 41.8712 13.002C37.0434 13.002 32.633 16.1324 31.0121 20.6541C30.1912 20.3341 29.3008 20.1672 28.4173 20.1672C24.473 20.1672 21.266 23.3741 21.266 27.3185C21.266 27.875 21.3286 28.4246 21.4608 28.9672C18.6225 30.282 16.7373 33.2107 16.7373 36.3411C16.7373 40.828 20.3895 44.4802 24.8764 44.4802H28.6608C29.586 44.4802 30.3373 43.7289 30.3373 42.8037C30.3373 41.8785 29.586 41.1272 28.6608 41.1272H24.8764C22.2399 41.1272 20.0903 38.9776 20.0903 36.3411C20.0903 34.0524 21.7182 32.0837 23.9651 31.6524C24.4938 31.555 24.946 31.2002 25.1756 30.7133C25.4051 30.2263 25.3773 29.6559 25.113 29.1828C24.793 28.6124 24.619 27.9654 24.619 27.3185C24.619 25.2246 26.3234 23.5133 28.4243 23.5133C29.3634 23.5133 30.2747 23.868 30.9773 24.508C31.4434 24.9254 32.0903 25.0576 32.6817 24.835C33.266 24.6193 33.6834 24.0976 33.7599 23.4785C34.2886 19.4089 37.7738 16.348 41.8782 16.348C46.3999 16.348 50.073 20.028 50.073 24.5428C50.073 25.0298 50.0243 25.5237 49.9269 26.0524C49.8225 26.602 50.0034 27.1654 50.4069 27.562C50.8034 27.9446 51.3669 28.1115 51.9234 28.0002C53.899 27.5828 55.9095 28.0559 57.4469 29.3011C59.019 30.5741 59.9234 32.4663 59.9234 34.4976C59.9234 38.1567 56.946 41.1411 53.2799 41.1411H51.353C50.4277 41.1411 49.6764 41.8924 49.6764 42.8176C49.6764 43.7428 50.4277 44.4941 51.353 44.4941H53.2799C58.7895 44.4941 63.2695 40.0141 63.2695 34.5046C63.2695 31.7289 62.1077 29.0506 60.0764 27.1585C58.2469 25.4472 55.8956 24.515 53.419 24.508V24.5011Z",
    fill: "url(#paint0_linear_849_484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3879 38.2051C38.8227 38.2051 37.3549 38.8103 36.2488 39.9164C36.0053 40.1599 35.8662 40.4868 35.8662 40.8346C35.8662 41.1825 35.9984 41.5094 36.2488 41.7529C36.4993 41.9964 36.8193 42.1355 37.1671 42.1355C37.5149 42.1355 37.8419 42.0033 38.0853 41.7529C39.3514 40.4868 41.4175 40.4868 42.6836 41.7529C43.1914 42.2607 44.0193 42.2607 44.5271 41.7529C44.7706 41.5094 44.9097 41.1825 44.9097 40.8346C44.9097 40.4868 44.7775 40.1599 44.5271 39.9164C43.421 38.8103 41.9532 38.2051 40.3879 38.2051Z",
    fill: "url(#paint1_linear_849_484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.395 33.5303C37.7933 33.5303 35.3446 34.539 33.5081 36.3755C33.2437 36.6398 33.0977 36.9877 33.0977 37.3633C33.0977 37.739 33.2437 38.0868 33.5081 38.3511C34.0368 38.8798 34.955 38.8798 35.4837 38.3511C36.7916 37.0433 38.5377 36.3198 40.395 36.3198C42.2524 36.3198 43.9985 37.0433 45.3064 38.3511C45.5707 38.6155 45.9185 38.7616 46.2942 38.7616C46.6698 38.7616 47.0177 38.6155 47.282 38.3511C47.5464 38.0868 47.6924 37.739 47.6924 37.3633C47.6924 36.9877 47.5464 36.6398 47.282 36.3755C45.4455 34.539 43.0037 33.5303 40.395 33.5303Z",
    fill: "url(#paint2_linear_849_484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3647 35.0049C50.6499 34.7197 50.8099 34.3371 50.8099 33.9266C50.8099 33.5162 50.6499 33.1405 50.3647 32.8484C47.6865 30.1701 44.1247 28.6953 40.3265 28.6953C36.5282 28.6953 32.9665 30.1701 30.2882 32.8484C29.6969 33.4397 29.6969 34.4066 30.2882 34.9979C30.8656 35.5753 31.8673 35.5684 32.4378 34.9979C36.7856 30.6501 43.8673 30.6501 48.2152 34.9979C48.5004 35.2831 48.883 35.4431 49.2934 35.4431C49.7039 35.4431 50.0795 35.2831 50.3717 34.9979L50.3647 35.0049Z",
    fill: "url(#paint3_linear_849_484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3958 42.4004C39.2062 42.4004 38.2393 43.3673 38.2393 44.5569C38.2393 45.7465 39.2062 46.7134 40.3958 46.7134C41.5853 46.7134 42.5523 45.7465 42.5523 44.5569C42.5523 43.3673 41.5853 42.4004 40.3958 42.4004Z",
    fill: "url(#paint4_linear_849_484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2026 0H19.4634C8.91736 0 0.333008 8.58435 0.333008 19.1304V60.8696C0.333008 71.4157 8.91736 80 19.4634 80H61.2026C71.7487 80 80.333 71.4157 80.333 60.8696V19.1304C80.333 8.58435 71.7487 0 61.2026 0ZM40.3052 54.8104L59.0878 68.96V76.5148H21.4461V69.0226L40.3052 54.8035V54.8104ZM76.8548 60.8696C76.8548 69.0435 70.5591 75.7635 62.5661 76.4591V71.5826L63.9921 72.6609C64.333 72.9183 64.7365 73.0574 65.1608 73.0574C65.2513 73.0574 65.3417 73.0574 65.4321 73.0365C65.9469 72.967 66.4061 72.6957 66.7121 72.2852C67.3591 71.4296 67.1921 70.2052 66.3295 69.5583L41.5643 50.9009C40.8826 50.3165 39.86 50.2817 39.1365 50.8243L14.3156 69.5235C13.8982 69.8435 13.6339 70.2957 13.5713 70.7965C13.4947 71.3183 13.6269 71.833 13.94 72.2435C14.58 73.0922 15.8043 73.2661 16.6669 72.6261L17.9608 71.6522V76.4452C10.0304 75.687 3.80431 68.9948 3.80431 60.8626V19.1304C3.81127 10.4974 10.8304 3.47826 19.4634 3.47826H61.2026C69.8356 3.47826 76.8548 10.4974 76.8548 19.1304V60.8696Z",
    fill: "url(#paint5_linear_849_484)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_849_484",
    x: 0.333008,
    y: 0,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_849_484"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_849_484",
    x1: 40.0034,
    y1: 13.002,
    x2: 40.0034,
    y2: 44.4941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_849_484",
    x1: 40.3879,
    y1: 38.2051,
    x2: 40.3879,
    y2: 42.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_849_484",
    x1: 40.395,
    y1: 33.5303,
    x2: 40.395,
    y2: 38.7616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_849_484",
    x1: 40.3273,
    y1: 28.6953,
    x2: 40.3273,
    y2: 35.4431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_849_484",
    x1: 40.3958,
    y1: 42.4004,
    x2: 40.3958,
    y2: 46.7134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_849_484",
    x1: 40.333,
    y1: 0,
    x2: 40.333,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartHomeIconCmu);
export default __webpack_public_path__ + "static/media/smart_home_icon_cmu.f24edfa10ae09cbd43f81fd20af2e612.svg";
export { ForwardRef as ReactComponent };